import {
  INVALIDATE_DETTES,
  INVALIDATE_DEPENSES,
  INVALIDATE_TRANSACTIONS,
  INVALIDATE_DETTES_CLIENT,
  INVALIDATE_ECRITURE,
} from 'actions/invalidationTags';
import { ApiMananger } from 'actions/rtkquery';
import {
  UPDATE_DETTE_API_ROUTE,
  PAIEMENT_DETTE_API_ROUTE,
} from 'routes/api/endpoints';

const detteApi = ApiMananger.injectEndpoints({
  endpoints: (build) => ({
    updateDette: build.mutation({
      query: ({ id, ...updateData }) => ({
        url: `${UPDATE_DETTE_API_ROUTE}${id}/`,
        method: 'PUT',
        body: updateData,
      }),
      invalidatesTags: [INVALIDATE_DETTES],
    }),
    payDette: build.mutation({
      query(body) {
        return {
          url: PAIEMENT_DETTE_API_ROUTE,
          method: 'POST',
          body,
        };
      },
      // Un paiement modifie le statut dans les dépenses, transactions
      // et les écritures comptables générées.
      invalidatesTags: [
        INVALIDATE_DETTES,
        INVALIDATE_DETTES_CLIENT,
        INVALIDATE_DEPENSES,
        INVALIDATE_TRANSACTIONS,
        INVALIDATE_ECRITURE,
      ],
    }),
  }),
  overrideExisting: false,
});

export const {
  useUpdateDetteMutation,
  usePayDetteMutation,
} = detteApi;
